// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"StackedRadiosGroup_wrapper__2jOOF","item":"StackedRadiosGroup_item__6aNSN","active":"StackedRadiosGroup_active__2WqJg"};